import React, { useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import styles from "./GalleryAnnualStorage.module.css";
import cart_r from "../../../assets/images/cart_r.png";
import useAxios from "../../Hooks/useAxios";
import { Link, useNavigate } from "react-router-dom";
import arrow_icon from "../../../assets/images/icons/arrow_icon.png";

const GalleryAnnualStorage = ({ hideCard }) => {
  const passObj = {
    1: "#EFEEE5",
    2: "#D9DEE3",
    3: "#CCCCCC",
    4: "#E8DBB3",
    5: "#ABC4B9",
  };

  const [popup, setPopup] = useState(false);
  const [items, setItems] = useState([]);
  // const items= [
  //   {
  //     annual_pass_type_id: 2,
  //     payment_type: "",
  //     payment_ref: "",
  //     payment_status: "OK",
  //     amount: 550
  //   }
  // ];
  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const handleOpenPopup = () => {
    setPopup(true);
    axios
      .get(backend_base + "/maintenance/annual-pass/purchase")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success", res.data);
          setItems(res.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleAddToCart = (item) => {
    const data = {
      annual_pass_id: item.id,
    };
    axios
      .post(backend_base + "/maintenance/annual-pass/cart", data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success");
          navigate("/cart-annual-pass");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleClosePopup = () => {
    setPopup(false);
  };
  return (
    <>
      <Header />
      <div
        className={styles.main_div}
        style={
          hideCard === undefined
            ? {
                marginTop: "calc(93px + 150px)",
                paddingBottom: "100px",
                height: "100%",
              }
            : {
                marginTop: "50px",
                borderTop: "1px solid #70707099",
                minHeight: "auto",
                height: "auto",
              }
        }
      >
        {!hideCard && (
          <div>
            <span className={styles.card}>ギャラリー年間保管パス</span>
          </div>
        )}
        <p className={styles.text}>
          3ヶ月の無料保管期間を過ぎた後も、MyAceにギャラリーを保管できるサービスです。（最大10Gまで）
          <br />
          延長する年数をお選びの上お手続きください。（1年保管パス〜５年保管パスまであります。）
        </p>
        <button
          className={`${styles.button} d-flex justify-content-end align-items-center m-auto`}
          style={{ cursor: "pointer" }}
          onClick={() => handleOpenPopup()}
        >
          <span>年間保管パスを購入</span>
          <img
            width={38}
            height={7}
            className={styles.upload_arrow_icon}
            style={{ transform: "translateX(15px)" }}
            src={arrow_icon}
            alt="arow icon"
          />
        </button>
        <hr className={`${styles.hr} mt-5`}></hr>
        <div className={styles.bottom}>
          <p>
            <span className={styles.bottom_div_header}>保管期限について</span>
          </p>
          <p className={styles.bottom_div_text}>
            3ヶ月無料期間終了前に決済をされた場合、3ヶ月無料期間終了日から1年間（もしくは契約の年数分）のカウントとなります。
            <br />
            例）無料期間終了日
            2022/03/03で、2022/02/01に1年間保管の決済をされた場合、2023/03/03まで保管されます。
          </p>
          <br />
          <p>
            <span className={styles.bottom_div_header}>
              期限切れデータを年間保管したい場合
            </span>
          </p>
          <p className={styles.bottom_div_text}>
            期限切れのデータを購入の上、クラウド保管のお手続きをお願いいたします。
            <Link to="/gallery-data-repuchase">▶︎期限切れデータの購入</Link>
          </p>
        </div>
      </div>
      <Footer />
      {popup && (
        <div className={styles.popup_main}>
          <div className={styles.popup}>
            <span className={styles.cross} onClick={() => handleClosePopup()}>
              X
            </span>
            <div className={styles.content}>
              <h5 className={styles.bold}>
                ギャラリーに保管する年数を選んでカートに入れてください。
              </h5>
              <div className={styles.main_content}>
                <p>
                  3ヶ月の無料保管期間を過ぎた後も、MyAceにギャラリーを保管できるサービスです。（最大10Gまで）
                  <br></br>
                  延長する年数をお選びの上お手続きください。（銀行振り込み不可）
                </p>
                <p>
                  年間パスの期限が終了する前に再度、年間パスをご購入いただくと保管期限は延長されます。
                  <br></br>
                  年間パスが切れてしまうと、データを購入していただくこととなりますのでご注意ください。（1プラン￥1,650）
                </p>
                <div>
                  <table className={styles.items}>
                    <tbody>
                      {Array.isArray(items) &&
                        items.length > 0 &&
                        items.map((item, index) => (
                          <tr className={styles.tr} key={index}>
                            <td>
                              <div
                                className={styles.pass}
                                style={{
                                  backgroundColor: passObj[item?.id],
                                }}
                              >
                                {item.name.length > 0 &&
                                  item.name.split(" ")[0]}
                                <br />
                                PASS
                              </div>
                            </td>
                            <td className={styles.year}>{item.year}年保管</td>
                            <td className={styles.money}>
                              {new Intl.NumberFormat("ja-JP", {
                                style: "currency",
                                currency: "JPY",
                              }).format(item.price)}
                            </td>
                            <td>
                              <button
                                className={styles.add_to_cart}
                                onClick={() => handleAddToCart(item)}
                              >
                                <img src={cart_r} alt="cart_icon" />
                                <span>カートに入れる</span>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryAnnualStorage;
